/**
 * Translate description: Filter component
 */

import { Fragment, useContext, useEffect, useState } from 'react';

import { useLanguageContext } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';

import { Input } from '@mui/joy';

export default () => {
    const { t } = useLanguageContext();
    const { setFilter, setPaginator } = useContext(AppContext);
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');
    useEffect(() => {
        const date_range = from || to ? { from, to } : undefined;
        setFilter(prev => ({ ...prev, date_range }));
        setPaginator(prev => ({ ...prev, currentPage: 1 }));
    }, [from, to])
    return (
        <Fragment>
            <FormControl size="sm">
                <FormLabel>{t('From')}</FormLabel>
                <Input type={'date'} size={'sm'} value={from} onChange={e => setFrom(e.target?.value)} />
            </FormControl>
            <FormControl size="sm">
                <FormLabel>{t('To')}</FormLabel>
                <Input type={'date'} size={'sm'} value={to} onChange={e => setTo(e.target?.value)} />
            </FormControl>
        </Fragment>
    )
};
